export default __webpack_public_path__ + "static/media/banner-vector.7086cdc2.png";